const colors = {
  PRIMARY: '#db9600',
  PRIMARY_STORNG: '#ffcf66',
  WHITE: '#000000',
  SECONDARY_LIGHT: 'rgba(0,0,0,0.7)',
  BLACK: '#FFFFFF',
  ERROR: '#03a5a5',
  SECONDARY_GREY: '#575757',
  PRIMARY_GREY: '#8a8a8a',
  LIGHT_GREY: '#6a6a6a',
  DARK_GREY: '#aaaaaa',
  GREEN: '#b050b6',
  TEAL: '#ff4949',
  BACKGROUND: '#070707',
  GREY_SEPARATOR: '#0f0f0f',
  ORANGE: '#0061ff',
  BORDER_COLOR: '#212121',
  BLUE_SHADE: '#ff823a',
  WHITE_SEPERATOR: '#0000001A',
  ALTO_DISABLED: 'rgba(39, 39, 39, 0.1)',
  BLACK_LIGHT: '#FFFFFF50',
  TRANSPARENT: '#00000000',
  WHITE_30: 'rgba(0, 0, 0, 0.3)',
  BLACK_75: 'rgba(255, 255, 255, 0.75)',
  BLACK_STRIKE: '#aaaaaa',
  HOTEL_PRIMARY: '#aaaaaa',
  HOTEL_PRIMARY_TRANSPARENT: '#aaaaaa4C',
  YELLOW: '#0046ff',
  TRANSPARENT45: 'rgba(255, 255, 255, 0.45)',
  RED: '#00ffff',
  BLUE_MAP: '#f3d496',
  WHITE45: 'rgba(0, 0, 0, 0.45)',
  VERY_LIGHT_GREY: '#bdbdbd32',
  INACTIVE_GREY: '#aaaaaa',
  WHITE30: 'rgba(0, 0, 0, 0.3)',
  PURE_BLACK: '#000000',
  SEPERATOR: '#272727',
  ITEM_SEPARATOR: '#222222',
  GRAY_HALF: '#090909',
  BLACK_GRAY_SHADE: '#cdcdcd',
  GREY_1_SEPARATOR: '#282828',
  PRIMARY_LIGHT_GREY: '#090909',
  LIGHT_GREY_SEPARATOR: '#282828',
  LIGHT_GREY_INTRO: '#424242',
  BLACK_SECONDARY: '#cdcdcd',
  LIGHT_BLUE_SEPARATOR: '#c8a65f',
  GRAY_BORDER: '#FFFFFF14',
  DISABLED_GREY: '#1f1f1f',
  BLACK_21: '#dedede',
  GRAY_SHADOW: '#FFFFFF29',
  LIGHT_BLACK: '#808080',
  TEST_MODE: '#1973cd',
  LIVE_MODE: '#ee3ec5',
  LIGHTEST_GREY: '#101010',
  LIGHTEST_GREY_2: '#0d0d0d',
  MEDIUM_GREY: '#959595',
  DARK_GREY_2: '#dddddd',
  GREY_WHITE: '#2247970F',
  GRAY_LIGHT: '#00000061',
  BLUE_TANCENT: 'rgb(55,181,232)',
  BACKGROUND_LIGHT: '#EEEEEE',
}

const dark = {
  colors,
}

export { dark }
